
<div class="container-fluid">
    <div class="row">
        <div class="col-12">


        </div>
    </div>
    <div class="row">
        <div class="col-12 mt-3">
            <isf-filter #filter (searchEvent)="search($event)" (clearEvent)="search($event)"></isf-filter>
        </div>
    </div>
</div>

<div class="container-fluid">
    <table class="table table-bordered table-sm mb-0">
        <thead class="font-weight-bold text-center btn-secondary">
            <tr>
                <!--
                <td>
                    <input type="checkbox" class="form-check-input form-check" [(ngModel)]="selectAll" (change)="selectAllItems()">
                </td>
                -->

              <!--  <td>Id</td> -->
                <td>Status</td>
                <td>Importer</td>
                <td class="d-sm-none d-lg-table-cell">Shipper/Seller</td>
                <td>Bills/Containers</td>
              <!--  <td>Description</td> -->
                <td class="d-block d-sm-none d-xs-none d-lg-table-cell">Vessel/ETA</td>
                <td class="d-block d-sm-none d-xs-none d-lg-table-cell">Created</td>
                <td>View</td>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let i of isf?.content">

                <!--
                <td style="width: 30px;">
                    <input type="checkbox" class="form-check-input form-check"
                           (change)="isfSelections($event,i.id)"
                           [disabled]="isSelectable(i)"
                           [checked]="selected.includes(i.id)"/>
                </td>
                -->

                <!--
                <td style="width: 55px;">
                    <span>{{i.id}}</span>
                    <span *ngIf="selected.includes(i.id)">
                        <span *ngIf="i.transactionNumber==null || i.transactionNumber==''" class="text-success">(A)</span>
                        <span *ngIf="i.transactionNumber != null && i.transactionNumber != '' " class="text-info">(R)</span>
                    </span>
                </td>
                   -->

                <td style="width: 100px;">
                    <isf-status [status]="i.status.toString()"></isf-status>
                    <span class="badge badge-light">{{i.transactionNumber}}</span>
                </td>

                <td>
                    <span class="small font-weight-bold">{{i.importer}}</span><br/>
                    <span class="badge badge-light text-secondary">{{i.importerNumber}}</span>
                </td>
                <td class="d-sm-none d-xs-none d-lg-table-cell">
                    <span class="small font-weight-bold">{{i.shipper}}</span>
                </td>
                <td>
                    <isf-bills [billData]="i.bills"></isf-bills>
                    <div class="small text-secondary">{{i.containers}}</div>
                </td>

                <!--
                <td>
                    <span class="text-secondary">{{i.description}}</span>
                </td>
                -->

                <td class="d-block d-sm-none d-xs-none d-lg-table-cell">
                    <div class="small font-weight-bold">{{i.vessel}}</div>
                    <span *ngIf="i.voyage != null" class="badge badge-light text-secondary"> Voyage:{{i.voyage}}</span>
                    <span *ngIf="i.eta != null" class="badge badge-light text-secondary"> ETA: {{i.eta | date:'shortDate'}}</span>
                </td>

                <td class="d-block d-sm-none d-xs-none d-lg-table-cell">
                    <span class="small font-weight-bold">{{i.createdAt | date:'short'}}</span><br/>
                    <span class="text-secondary">{{i.createdBy}}</span>
                </td>
                <td>
                    <button class="btn btn-sm btn-secondary small w-100" (click)="view(i.id)">
                        <i class="fa fa-eye small"></i> <span class="small"> View</span>
                    </button>
                </td>

            </tr>
        </tbody>
        <tfoot></tfoot>
    </table>
    <ngb-pagination
            [collectionSize]="isf.totalElements"
            (pageChange)="pageChange($event)"
            [maxSize]="5"
            [pageSize] = "isf.size"
            [(page)]="filterData.page"
            [boundaryLinks]="true"
            [rotate]="false"
            [directionLinks]="true">
    </ngb-pagination>
</div>
